import firebase from '../firebase'
import DataHelpers from '../helpers/DataHelpers'
import FireData from './FireData';
import Utilities from '../helpers/Utilities'
import FirebaseHelpers from '../helpers/FirebaseHelpers'

var db = firebase.database()

export default class {

static fetchContactSingle(contactKey) {
    return new Promise( (resolve, reject) => {
        let ref = DataHelpers.getTenantRef().child('contacts')
        FireData.fetchItemSingle(ref.child(contactKey)).then( (contact) => {
            resolve(contact)
        })        
    })
}

static fetchUsers() {
    return new Promise( (resolve, reject) => {
        let r = DataHelpers.getTenantRef()
        console.log('tenant is ', r.toString())
        let ref = DataHelpers.getTenantRef().child('contacts').orderByChild('user').equalTo(true)
        FireData.fetchItems(ref).then( (users) => {
            users.forEach( user => {
                user.uid = user.key
            })
            resolve(users)
        })        
    })
}

static fetchContactsForRole(role) {
    return new Promise( (resolve, reject) => {

        let ref = DataHelpers.getTenantRef().child('contacts')

        //blank role returns all
        if(role) 
            ref = ref.orderByChild('groups/' + role).equalTo(true)
        else    
            ref = ref.orderByChild('user').equalTo(true)

        ref = ref.limitToFirst(20)
            
        ref.once('value', (snap) => {
            const elements = this.snapshotToArray(snap)
            resolve(elements.filter(c => c.user))
        })
    })
}

// This newer version doesn't set a '.key' value, only 'key'
static snapshotToArray(snapshot) {
    let returnArr = []
    snapshot.forEach(childSnapshot => {
        let item = childSnapshot.val()
        item.key = childSnapshot.key
        item.uid = childSnapshot.key
        item.meta = {
            key: childSnapshot.key
        }
        returnArr.push(item)
    })

    return returnArr
}

static contactTransactionAdd(contactKey, transactionKey) {
    let transactionRef = DataHelpers.getTenantRef().child('transactions').child(transactionKey).child('details')
    FireData.fetchItemSingle(transactionRef).then( (transaction) => {
        transaction.key = transactionKey
        const ref = DataHelpers.getTenantRef().child('contactTransactions').child(contactKey)
        FireData.saveItem(transaction, ref)
    })
}

} // end class


// WEBPACK FOOTER //
// ./src/data/ContactData.js